import { Logo } from '../../ui/components/Logo/Logo';
import { createOpenAIModalCommand } from '../decoration/actions';
export const floatingToolbarAIButtonTestID = `ak-editor-ai-selection-toolbar-ai-button`;
export const floatingToolbarAIDropdownTestIDPrefix = `ak-editor-ai-selection-toolbar-dropdown-`;
import { messages } from './selection-toolbar-messages';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';
export const getAIExperienceButton = ({
  intl,
  rangeBaseGenerate,
  hideTitle,
  aiGlobalOptIn
}) => {
  let didMouseEnter = false;
  return {
    type: 'button',
    showTitle: true,
    testId: floatingToolbarAIButtonTestID,
    icon: Logo,
    ...(!hideTitle && {
      title: intl.formatMessage(messages.aiToolbarTitle)
    }),
    tooltipContent: intl.formatMessage(sharedMessages.aiUniversalShortCallToAction),
    disabled: false,
    onMouseEnter: () => {
      didMouseEnter = true;
      return false;
    },
    onClick: (state, dispatch, view) => {
      const openAIModalCommand = createOpenAIModalCommand({
        state,
        configItem: rangeBaseGenerate,
        lastTriggeredFrom: 'floatingToolbar',
        // ED-18194 Added analytics for floating toolbar to determine
        // the % of users who click the button vs shift tab to it
        triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
        aiGlobalOptIn
      });
      openAIModalCommand(state, dispatch);
      return false;
    }
  };
};
const mapSelectionToolbarDropdowns = ({
  selectionToolbarDropdowns,
  intl,
  aiGlobalOptIn
}) => {
  if (!selectionToolbarDropdowns) {
    return [];
  }
  return selectionToolbarDropdowns.map(dropdownConfig => {
    let title = intl.formatMessage(dropdownConfig.label);
    if (dropdownConfig !== null && dropdownConfig !== void 0 && dropdownConfig.beta) {
      title = `${title} (${intl.formatMessage(sharedMessages.betaLabel)})`;
    }
    return {
      type: 'dropdown',
      testId: floatingToolbarAIDropdownTestIDPrefix + dropdownConfig.id,
      title: title,
      tooltip: title,
      disabled: false,
      options: dropdownConfig.options.map((option, index) => ({
        title: intl.formatMessage(option.label),
        testId: `ak-editor-ai-selection-toolbar-${dropdownConfig.id}-button-${index}`,
        onClick: (state, dispatch, view) => {
          const openAIModalCommand = createOpenAIModalCommand({
            state,
            configItem: option.configItem,
            lastTriggeredFrom: 'floatingToolbarDropdown',
            // ED-18194 Added analytics for floating toolbar to determine
            // the % of users who click the button vs shift tab to it
            // triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
            aiGlobalOptIn
          });
          openAIModalCommand(state, dispatch);
          return false;
        }
      }))
    };
  });
};
export const getAIExperienceDropdowns = ({
  intl,
  rangeConfig,
  aiGlobalOptIn
}) => {
  var _rangeConfig$getSelec;
  const selectionToolbarDropdowns = (_rangeConfig$getSelec = rangeConfig.getSelectionToolbarDropdowns) === null || _rangeConfig$getSelec === void 0 ? void 0 : _rangeConfig$getSelec.call(rangeConfig);
  const aiDropdowns = mapSelectionToolbarDropdowns({
    selectionToolbarDropdowns,
    intl,
    aiGlobalOptIn
  });
  const separator = {
    type: 'separator'
  };
  const separatedAIDropdowns = aiDropdowns.reduce((acc, val) => acc.concat(separator, val), []);
  return separatedAIDropdowns;
};
export const getAIExperiencePromptButton = ({
  intl,
  rangeConfig,
  aiGlobalOptIn
}) => {
  var _rangeConfig$getSelec2, _selectionToolbarProm;
  let didMouseEnter = false;
  const selectionToolbarPromptButton = (_rangeConfig$getSelec2 = rangeConfig.getSelectionToolbarPromptButton) === null || _rangeConfig$getSelec2 === void 0 ? void 0 : _rangeConfig$getSelec2.call(rangeConfig);
  if (!selectionToolbarPromptButton) {
    return;
  }
  const icon = (_selectionToolbarProm = selectionToolbarPromptButton.configItem) !== null && _selectionToolbarProm !== void 0 && _selectionToolbarProm.icon ? () => {
    var _selectionToolbarProm2;
    return (
      // extra check for icon to satisfy TS
      ((_selectionToolbarProm2 = selectionToolbarPromptButton.configItem) === null || _selectionToolbarProm2 === void 0 ? void 0 : _selectionToolbarProm2.icon) && selectionToolbarPromptButton.configItem.icon({
        formatMessage: intl.formatMessage,
        shownAt: 'suggestions'
      })
    );
  } : undefined;
  return {
    id: selectionToolbarPromptButton.id,
    type: 'button',
    title: selectionToolbarPromptButton.configItem.title({
      formatMessage: intl.formatMessage
    }),
    showTitle: true,
    testId: `ak-editor-ai-selection-toolbar-${selectionToolbarPromptButton.id}-button`,
    ...((selectionToolbarPromptButton === null || selectionToolbarPromptButton === void 0 ? void 0 : selectionToolbarPromptButton.tooltip) && {
      tooltipContent: intl.formatMessage(selectionToolbarPromptButton.tooltip)
    }),
    icon,
    onMouseEnter: () => {
      didMouseEnter = true;
      return false;
    },
    onClick: (state, dispatch, view) => {
      const openAIModalCommand = createOpenAIModalCommand({
        state,
        configItem: selectionToolbarPromptButton.configItem,
        lastTriggeredFrom: 'floatingToolbarPromptButton',
        // ED-18194 Added analytics for floating toolbar to determine
        // the % of users who click the button vs shift tab to it
        triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
        aiGlobalOptIn
      });
      openAIModalCommand(state, dispatch);
      return false;
    }
  };
};